import type { FaireProductEntity } from "../../entity_types/product";

export const p_j888jbdhyb: FaireProductEntity = {
  token: "p_j888jbdhyb",
  type: "product",
  name: "Quill Wreath Ornament",
  brandToken: "b_42bfa9c9",
  brandName: "Ten Thousand Villages",
  imageUrl:
    "https://cdn.faire.com/fastly/a764004a693d4860ca3ae0b4a812f1d17cf4371f2a25b3c34a4c03df5ebc3638.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d0207436b3565e0c70e491b9ee46aac7398a6ab72c66733db35bb6aa3639513c.jpeg",
    "https://cdn.faire.com/fastly/e864b46ace398618df84867449e450561f69cb495d36c9921f9b8377cfc6cc5d.jpeg",
  ],
  priceDollars: 5.5,
  description:
    "This carefully quilled paper wreath will look stunning on your classic holiday tree. It harkens back to simpler times when decorations were all handmade and passed down from one generation to the next.",
  tags: [],
  msrpDollars: 10.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
